import { minutesToMillis } from '@csp/csp-common-date-util';
import { useIdleTimer } from '@csp/web-common';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_MINUTES_TO_LOGOUT } from '@csp/csp-common-config';
import { getUserSelector } from '../ducks/principalContextSelectors';
//TODO:[Saman M]: remove comment out codes when @zoomus/websdk package is installed
//import { useZoomContext } from '../../video-meeting/zoom/context/hook/useZoomContext';
import { useStudiesContext } from '../../../common/context/studies/useStudiesContext';
import { useAuthContext } from '../../auth/context/hook/useAuthContext';
import { useAutomaticLogoutContext } from '../context/hook/useAutomaticLogoutContext';
import { useSignOut } from './useSignOut';

export const useAutomaticLogout = (): void => {
  const { isAuthenticated } = useAuthContext();
  const user = useSelector(getUserSelector);
  const { signOut } = useSignOut();
  const { selectedStudyId, selectedStudyConfig } = useStudiesContext();
  const { onPreAutomaticLogout } = useAutomaticLogoutContext();
  //const { endMeeting } = useZoomContext();
  const millisIdleToAutoLogout = minutesToMillis(
    selectedStudyConfig?.webPortalClientConfig.minutesIdleToAutoLogout || DEFAULT_MINUTES_TO_LOGOUT,
  );
  const memoizedSignOutAndReload = useCallback(async () => {
    if (isAuthenticated) {
      onPreAutomaticLogout({
        userId: user?.userId,
        path: window.location.pathname,
        studyId: selectedStudyId,
      });
      // await endMeeting();
      await signOut();
    }
  }, [isAuthenticated, onPreAutomaticLogout, user, selectedStudyId, signOut /*endMeeting ,*/]);

  useIdleTimer(millisIdleToAutoLogout, memoizedSignOutAndReload);
};
